import { getRegisterFunction } from '../../utils/register.js';
import { OneUxPopoutElement } from './OneUxPopoutElement.js';
export const register = getRegisterFunction(OneUxPopoutElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-popout': OneUxPopoutElement;
    "popout-f0dd5afe64d416b2355e804b44eb5b0d": OneUxPopoutElement;
  }
}